import api from '.';
import {
  CareProfileAnswer,
  CareProfileCategory,
  CareProfileAnswerRequest,
  CareProfileFormEvent,
} from '@karehero/models';

export const careProfileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllCategoryByProfile: builder.query<CareProfileCategory[], string>({
      query: (id) => `/care-profile/${id}/category`,
      providesTags: ['CareProfileCategories'],
      keepUnusedDataFor: 0,
    }),
    getCareProfileAnswers: builder.query<CareProfileAnswer[], string>({
      query: (careProfileId) => `care-profile/${careProfileId}/answer`,
      providesTags: ['CareProfileAnswers'],
    }),
    createManyAnswer: builder.mutation<void, CareProfileAnswerRequest>({
      query: (body: CareProfileAnswerRequest) => ({
        url: `care-profile/${body.careProfileId}/answer`,
        method: 'POST',
        body: body.answers,
      }),
      invalidatesTags: ['CareProfileCategories', 'CareProfileAnswers'],
    }),
    submitCareProfileForm: builder.mutation<void, CareProfileFormEvent>({
      query: (careProfileFormEvent: CareProfileFormEvent) => ({
        url: `/care-profile/${careProfileFormEvent.careProfileId}/category/${careProfileFormEvent.careProfileCategoryId}/submit`,
        method: 'POST',
        body: {
          eventType: careProfileFormEvent.eventType,
        },
      }),
    }),
  }),
});

export const {
  useGetCareProfileAnswersQuery,
  useGetAllCategoryByProfileQuery,
  useCreateManyAnswerMutation,
  useSubmitCareProfileFormMutation,
} = careProfileApi;

export const invalidateCareProfileTags = () => {
  return careProfileApi.util.invalidateTags(['CareProfileCategories']);
};

export default careProfileApi;
